import React from 'react'

import styles from './search-dropdown.css'
import Loader from '../../loader/loader'

const SearchDropdown = (props) => {
  const { isLoading, children } = props

  return (
    <div className={styles.dropdown}>
      <Loader visible={isLoading} customClass={styles.loader} />
      {children}
    </div>
  )
}

export default SearchDropdown
